import {
  NexoyaAttributionRuleFilters,
  NexoyaContentRuleFilters,
  NexoyaContentV2,
  NexoyaImpactGroupRuleFilters,
  NexoyaProvider,
} from '../../../types';

export const CONTENT_TYPE_SUB_ACCOUNT_NUMBER = 2;

/**
 * A rule can reference a provider that `activeProviders` (`hasCollections=true` subset)
 * filters out, and its chip would then render translate()'s misleading "No data". So this
 * prefers the unfiltered `providersMap` and only falls back to the active list.
 */
export const findProviderForChip = (
  providerId: number,
  providersMap: Map<number, NexoyaProvider>,
  activeProviders: NexoyaProvider[],
): NexoyaProvider | undefined => {
  if (!Number.isFinite(providerId)) return undefined;
  return providersMap.get(providerId) ?? activeProviders.find((p) => p.provider_id === providerId);
};

export const extractProviderMapFromFilters = (
  filter: NexoyaContentRuleFilters | NexoyaImpactGroupRuleFilters | NexoyaAttributionRuleFilters,
  subAccounts: NexoyaContentV2[],
): Record<number, number[]> => {
  const providerMap: Record<number, number[]> = {};

  const isContentRuleOrAttributionRule = (filter: any): filter is NexoyaContentRuleFilters =>
    filter.__typename === 'ContentRuleFilters' || filter.__typename === 'AttributionRuleFilters';

  const providerIds = isContentRuleOrAttributionRule(filter)
    ? [filter.providerId]
    : // @ts-expect-error
      filter.providers.map((p) => p.providerId);

  const parentContentIds = isContentRuleOrAttributionRule(filter)
    ? filter.adAccountIds
    : // @ts-expect-error
      filter.providers.flatMap((p) => p.adAccountIds);

  // Find matching subAccounts and map their providers to content IDs
  // Use sourceProvider to match how rules are created (ProviderDropdownFilter uses sourceProvider)
  for (const providerId of providerIds) {
    const matchingSubAccounts = subAccounts.filter(
      (account) => account.sourceProvider?.provider_id === providerId && parentContentIds?.includes(account.contentId),
    );

    if (!providerMap[providerId]) {
      providerMap[providerId] = [];
    }

    matchingSubAccounts.forEach((account) => {
      providerMap[providerId].push(account.contentId);
    });
  }

  return providerMap;
};
